import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSettingComponent } from './components/user-setting/user-setting.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AllUsersResolver } from './resolvers/all-users.resolver';
import { TogglerComponent } from './components/toggler/toggler.component';
import { ResourceListComponent } from './components/resource-list/resource-list.component';
import { ContPaginatorModule } from '../cont-paginator/cont-paginator.module';
import { ProjectsResolver } from './resolvers/projects.resolver';
import { ProjectResolver } from './resolvers/project-resolver';
import { ClaimsListComponent } from './components/claims-list/claims-list.component';
import { PikadayControlComponent } from './components/pikaday-control/pikaday-control.component';
import { TimeFrameSelectComponent } from './components/time-frame-select/time-frame-select.component';
import { SearchSelectComponent } from './components/search-select/search-select.component';
import { ResourceFilterComponent } from "./components/resource-filter/resource-filter.component"
import { RouterModule } from '@angular/router';
import { CustomPropertiesResolver } from './resolvers/custom-properties.resolver';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InspectionPropertiesResolver} from "./resolvers/inspection-properties.resolver";
import { AuditTrailsUsersResolver } from "./resolvers/audit-trails-users.resolver";
import { ShipmentTemplatesResolver } from './resolvers/shipment-templates.resolver';
import { ShipmentWarningsTemplatesResolver } from './resolvers/shipment-warnings-templates.resolver';
import { ShipmentContactsTemplatesResolver } from './resolvers/shipment-contacts-templates.resolver';

import { ModuleFederationToolsModule } from '@angular-architects/module-federation-tools';
import { TooltipComponent } from './components/tooltip/tooltip.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ContPaginatorModule,
        RouterModule,
        FontAwesomeModule,
        ModuleFederationToolsModule,
    ],
    providers: [
        AllUsersResolver,
        AuditTrailsUsersResolver,
        ProjectsResolver,
        ProjectResolver,
        CustomPropertiesResolver,
        InspectionPropertiesResolver,
        ShipmentTemplatesResolver,
        ShipmentWarningsTemplatesResolver,
        ShipmentContactsTemplatesResolver,
        TooltipComponent
    ],
    declarations: [
        UserSettingComponent,
        TogglerComponent,
        ResourceListComponent,
        ResourceFilterComponent,
        ClaimsListComponent,
        PikadayControlComponent,
        TimeFrameSelectComponent,
        SearchSelectComponent,
        TooltipComponent
    ],
    exports: [
        CommonModule,
        ContPaginatorModule,
        ReactiveFormsModule,
        UserSettingComponent,
        TogglerComponent,
        ResourceListComponent,
        ResourceFilterComponent,
        ClaimsListComponent,
        TimeFrameSelectComponent,
        SearchSelectComponent,
        TooltipComponent,
        RouterModule,
        FontAwesomeModule,
        ModuleFederationToolsModule,
    ]
})
export class SharedModule { }
